import { trackCsEvent } from 'app/client/analytics';
import { getEnvelope } from 'app/client/analytics/utils';

// https://dataportal.zillowgroup.net/event-registry/5983
export const emitTrackGoogleLoginEvent = () => {
  trackCsEvent({
    envelope: getEnvelope({
      eventId: '5983',
      eventVersion: '1',
      templateId: '171',
      templateVersion: '1',
    }),
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'login_screen',
      trigger_source_nm: 'button_to_google_login',
      trigger_object_nm: 'login_screen|auth_form',
    },
    semantic: {
      semantic_event_nm: 'google_login',
      topic_tag_txt: [],
    },
  });
};

// https://dataportal.zillowgroup.net/event-registry/5985
export const emitTrackHeaderLoginEvent = () => {
  trackCsEvent({
    envelope: getEnvelope({
      eventId: '5985',
      eventVersion: '1',
      templateId: '171',
      templateVersion: '1',
    }),
    clickstream_trigger: {
      trigger_type_nm: 'interaction',
      trigger_location_nm: 'hp_header',
      trigger_source_nm: 'link_to_sign_in',
      trigger_object_nm: 'hp_header|login_component',
    },
    semantic: {
      semantic_event_nm: 'header_sign_in_click',
      topic_tag_txt: [],
    },
  });
};
